import type { IRepairActionFilters } from '@/types/rc/filters'
import type { IRepairActionForm } from '@/types/rc/forms'
import type { IRepairAction } from '@/types/rc/miners'
import axios from 'axios'

/**
 * Gets all repair actions.
 *
 * @returns an array of JS objects representing repair actions.
 */
export async function getAllRepairActions(filters?: IRepairActionFilters): Promise<IRepairAction[]> {
  const res = await axios.get(import.meta.env.VITE_APP_RC_REPAIR_ACTIONS_ENDPOINT, {
    params: filters,
  })
  return res.data
}

/**
 * Delete a repair action.
 *
 * @param repairActionID the repair action ID
 */
export async function deleteRepairAction(repairActionID: number) {
  const res = await axios.delete(`${import.meta.env.VITE_APP_RC_REPAIR_ACTIONS_ENDPOINT}/${repairActionID}`)
  return res.data
}

/**
 * Create a repair action.
 *
 * @param data repair action data
 * @throws {AxiosError}
 */
export async function createRepairAction(data: IRepairActionForm): Promise<IRepairAction> {
  const res = await axios.post(`${import.meta.env.VITE_APP_RC_REPAIR_ACTIONS_ENDPOINT}`, data)
  return res.data
}

/**
 * Update a repair action by id.
 *
 * @param id repair action id
 * @param data repair action update data
 */
export async function updateRepairAction(id: number, data: IRepairActionForm): Promise<IRepairAction> {
  const res = await axios.put(`${import.meta.env.VITE_APP_RC_REPAIR_ACTIONS_ENDPOINT}/${id}`, data)
  return res.data
}
